import Section from '../Section';
import SectionContents from '../SectionContents';
import SectionContentsBody from '../SectionContentsBody';
import NonCompliant from './NonCompliant';
import local from './NonCompliant.module.scss';

export default function LandingNonCompliant() {
  return (
    <Section>
      <SectionContents sizes={{xs: [12, 12], lg: [12, 12]}}>
        <div className={local['landing--non-compliant']}>
          <SectionContentsBody
            title={<>Non-Compliant Suppliers Put Your Business at Risk</>}
            description={
              <>
                A single non-compliant supplier can cause recalls, legal
                penalties, reputational damage, or even safety incidents. In
                regulated industries, one failure can disrupt your entire supply
                chain.
              </>
            }
          />
        </div>
      </SectionContents>
      <NonCompliant />
    </Section>
  );
}
